export interface SEOArticle {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  imageSeq: string;
  date: string;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string;
}

export const featuredArticles: SEOArticle[] = [
  {
    slug: "/co-to-jest-kakobuy-spreadsheet",
    title: "Co to jest Kakobuy Spreadsheet?",
    excerpt: "Definicja, zastosowanie i dlaczego warto korzystać w 2026 roku. Poznaj naszą kompletną bazę produktową.",
    category: "Poradnik",
    imageSeq: "article-what-is-01",
    date: "2026-06-15",
    seoTitle: "Co to jest Kakobuy Spreadsheet? Kompletny Przewodnik 2026 | Kakobuy Spreadsheet Polska",
    seoDescription: "Dowiedz się czym jest Kakobuy Spreadsheet — zaawansowana baza produktowa agregująca setki zweryfikowanych ofert z Chin. Codzienna aktualizacja, 14 kategorii, bezpieczne linki. Sprawdź teraz!",
    seoKeywords: "co to jest kakobuy spreadsheet, kakobuy spreadsheet, baza produktów kakobuy, arkusz kakobuy, spreadsheet kakobuy poradnik",
  },
  {
    slug: "/jak-zamawiac-kakobuy",
    title: "Jak Zamawiać przez Kakobuy?",
    excerpt: "Instrukcja krok po kroku — od wyboru produktu do bezpiecznej płatności i śledzenia przesyłki.",
    category: "Poradnik",
    imageSeq: "article-how-to-02",
    date: "2026-06-10",
    seoTitle: "Jak Zamawiać przez Kakobuy? Instrukcja Krok po Kroku 2026 | Kakobuy Spreadsheet",
    seoDescription: "Kompletny poradnik jak zamawiać przez Kakobuy — od wyboru produktu w spreadsheet, przez bezpieczną płatność, po śledzenie przesyłki. Sprawdzone metody dla Polaków.",
    seoKeywords: "jak zamawiać kakobuy, kakobuy poradnik, zamawianie kakobuy, kakobuy spreadsheet instrukcja, jak kupować kakobuy",
  },
  {
    slug: "/kakobuy-vs-pandabuy",
    title: "Kakobuy vs Pandabuy — Porównanie 2026",
    excerpt: "Szczegółowe porównanie dwóch najpopularniejszych agentów zakupowych. Ceny, wysyłka, obsługa klienta.",
    category: "Porównanie",
    imageSeq: "article-vs-03",
    date: "2026-06-08",
    seoTitle: "Kakobuy vs Pandabuy — Porównanie Agentów Zakupowych 2026 | Kakobuy Spreadsheet",
    seoDescription: "Szczegółowe porównanie Kakobuy vs Pandabuy: ceny, szybkość wysyłki, jakość obsługi klienta i bezpieczeństwo. Który agent zakupowy jest lepszy dla Polaków w 2026 roku?",
    seoKeywords: "kakobuy vs pandabuy, porównanie agentów zakupowych, kakobuy pandabuy, który agent lepszy, spreadsheet kakobuy",
  },
  {
    slug: "/bezpieczne-zakupy-chiny",
    title: "Bezpieczne Zakupy w Chinach — Poradnik",
    excerpt: "Jak uniknąć oszustw i chronić swoje pieniądze podczas zakupów przez chińskich agentów. Praktyczne wskazówki.",
    category: "Poradnik",
    imageSeq: "article-safe-04",
    date: "2026-06-05",
    seoTitle: "Bezpieczne Zakupy w Chinach — Poradnik 2026 | Kakobuy Spreadsheet Polska",
    seoDescription: "Jak bezpiecznie robić zakupy w Chinach? Sprawdzone zasady, ochrona kupującego, unikanie oszustw. Poradnik oparty na doświadczeniach z Kakobuy Spreadsheet — zweryfikowane linki.",
    seoKeywords: "bezpieczne zakupy chiny, kakobuy bezpieczeństwo, ochrona kupującego chiny, zakupy chiny poradnik, kakobuy spreadsheet",
  },
  {
    slug: "/darmowy-kakobuy-spreadsheet",
    title: "Darmowy Kakobuy Spreadsheet — Czy Warto?",
    excerpt: "Czy darmowe arkusze Kakobuy są bezpieczne? Porównujemy darmowe i płatne opcje na 2026 rok.",
    category: "Poradnik",
    imageSeq: "article-free-05",
    date: "2026-06-03",
    seoTitle: "Darmowy Kakobuy Spreadsheet — Czy Warto? Opinie 2026 | Kakobuy Spreadsheet",
    seoDescription: "Czy darmowy Kakobuy Spreadsheet jest bezpieczny i wart uwagi? Porównujemy darmowe i płatne arkusze Kakobuy — zalety, wady, bezpieczeństwo i aktualność danych na 2026 rok.",
    seoKeywords: "darmowy kakobuy spreadsheet, kakobuy za darmo, spreadsheet kakobuy darmowy, kakobuy arkusz, kakobuy spreadsheet poradnik",
  },
  {
    slug: "/najlepsze-buty-kakobuy",
    title: "Najlepsze Buty Kakobuy — Ranking 2026",
    excerpt: "Top 20 sneakersów i butów dostępnych przez Kakobuy Spreadsheet. Jordan, Nike, Adidas i więcej.",
    category: "Ranking",
    imageSeq: "article-shoes-06",
    date: "2026-06-01",
    seoTitle: "Najlepsze Buty Kakobuy — Ranking Sneakersów 2026 | Kakobuy Spreadsheet",
    seoDescription: "Top 20 najlepszych butów dostępnych przez Kakobuy Spreadsheet: Jordan, Nike, Adidas, sneakersy i więcej. Sprawdzone linki, ceny i opinie — codzienna aktualizacja 2026.",
    seoKeywords: "najlepsze buty kakobuy, buty kakobuy ranking, sneakersy kakobuy, jordan spreadsheet, nike kakobuy, adidas kakobuy",
  },
  {
    slug: "/streetwear-kakobuy-spreadsheet",
    title: "Streetwear w Kakobuy Spreadsheet",
    excerpt: "Kompletny przewodnik po streetwearze — bluzy, koszulki, kurtki i akcesoria od najlepszych sprzedawców.",
    category: "Poradnik",
    imageSeq: "article-streetwear-07",
    date: "2026-05-28",
    seoTitle: "Streetwear w Kakobuy Spreadsheet — Przewodnik 2026 | Kakobuy Spreadsheet",
    seoDescription: "Kompletny przewodnik po streetwearze w Kakobuy Spreadsheet: bluzy, koszulki, kurtki i akcesoria od zweryfikowanych sprzedawców. Najlepsze marki i okazje w jednym arkuszu.",
    seoKeywords: "streetwear kakobuy, streetwear spreadsheet, bluzy kakobuy, koszulki kakobuy, kurtki kakobuy, moda uliczna kakobuy",
  },
  {
    slug: "/czy-kakobuy-jest-bezpieczny",
    title: "Czy Kakobuy Jest Bezpieczny? Opinie 2026",
    excerpt: "Analiza bezpieczeństwa platformy Kakobuy. Ochrona kupującego, metody płatności i opinie użytkowników.",
    category: "Bezpieczeństwo",
    imageSeq: "article-safety-08",
    date: "2026-05-25",
    seoTitle: "Czy Kakobuy Jest Bezpieczny? Opinie i Analiza 2026 | Kakobuy Spreadsheet",
    seoDescription: "Sprawdzamy czy Kakobuy jest bezpieczny — analiza ochrony kupującego, metod płatności, opinii użytkowników i zabezpieczeń platformy. Rzetelna ocena dla polskich kupujących.",
    seoKeywords: "czy kakobuy jest bezpieczny, kakobuy opinie, kakobuy bezpieczeństwo, kakobuy ochrona kupującego, spreadsheet kakobuy",
  },
  {
    slug: "/kakobuy-finds",
    title: "Kakobuy Finds — Najlepsze Znaleziska 2026",
    excerpt: "Kolekcja najbardziej popularnych i najlepiej ocenianych produktów z naszego spreadsheet Kakobuy.",
    category: "Ranking",
    imageSeq: "article-finds-09",
    date: "2026-05-20",
    seoTitle: "Kakobuy Finds — Najlepsze Znaleziska i Produkty 2026 | Kakobuy Spreadsheet",
    seoDescription: "Kakobuy Finds — kolekcja najlepszych znalezisk i najwyżej ocenianych produktów z Kakobuy Spreadsheet. Sprawdzone linki, aktualne ceny, popularne kategorie — codziennie aktualizowane.",
    seoKeywords: "kakobuy finds, najlepsze znaleziska kakobuy, kakobuy produkty, kakobuy spreadsheet, kakobuy links",
  },
  {
    slug: "/kakobuy-links",
    title: "Kakobuy Links — Kompletny Przewodnik",
    excerpt: "Zbiór wszystkich aktywnych linków Kakobuy posegregowanych kategoriami. Codziennie aktualizowane.",
    category: "Poradnik",
    imageSeq: "article-links-10",
    date: "2026-05-18",
    seoTitle: "Kakobuy Links — Kompletny Zbiór Linków 2026 | Kakobuy Spreadsheet",
    seoDescription: "Kakobuy Links — kompletny zbiór wszystkich aktywnych linków posegregowanych kategoriami. Codziennie aktualizowane linki do zweryfikowanych produktów — Shoes, Hoodies, T-Shirts i więcej.",
    seoKeywords: "kakobuy links, linki kakobuy, kakobuy spreadsheet linki, kakobuy produkty linki, kakobuy finds",
  },
  {
    slug: "/kakobuy-yupoo",
    title: "Kakobuy Yupoo — Jak Znaleźć Produkty?",
    excerpt: "Poznaj integrację Kakobuy z Yupoo. Jak przeglądać galerie, weryfikować sprzedawców i znaleźć najlepsze oferty.",
    category: "Poradnik",
    imageSeq: "article-yupoo-11",
    date: "2026-05-15",
    seoTitle: "Kakobuy Yupoo — Jak Znaleźć Produkty? Poradnik 2026 | Kakobuy Spreadsheet",
    seoDescription: "Poznaj integrację Kakobuy z Yupoo — jak przeglądać galerie, weryfikować sprzedawców i znaleźć najlepsze oferty. Praktyczny poradnik dla kupujących przez Kakobuy Spreadsheet.",
    seoKeywords: "kakobuy yupoo, yupoo kakobuy, jak znaleźć produkty kakobuy, kakobuy galerie, spreadsheet kakobuy yupoo",
  },
  {
    slug: "/jak-dziala-kakobuy-spreadsheet",
    title: "Jak Działa Kakobuy Spreadsheet?",
    excerpt: "Poznaj mechanizm działania naszego arkusza i dowiedz się, jak efektywnie z niego korzystać krok po kroku.",
    category: "Poradnik",
    imageSeq: "article-how-works-12",
    date: "2026-05-12",
    seoTitle: "Jak Działa Kakobuy Spreadsheet? Mechanizm i Zastosowanie 2026 | Kakobuy Spreadsheet",
    seoDescription: "Dowiedz się jak działa Kakobuy Spreadsheet — mechanizm weryfikacji produktów, codzienna aktualizacja, kategorie i bezpieczne linki. Poznaj narzędzie, które ułatwia zakupy w Chinach.",
    seoKeywords: "jak działa kakobuy spreadsheet, kakobuy spreadsheet mechanizm, arkusz kakobuy działanie, spreadsheet kakobuy, kakobuy poradnik",
  },
  {
    slug: "/najlepszy-agent-zakupowy-2026",
    title: "Najlepszy Agent Zakupowy 2026 — Ranking",
    excerpt: "Porównanie wszystkich popularnych agentów: ceny, wysyłka, obsługa. Który jest najlepszy dla Polaków?",
    category: "Porównanie",
    imageSeq: "article-best-agent-13",
    date: "2026-05-08",
    seoTitle: "Najlepszy Agent Zakupowy 2026 — Ranking i Porównanie | Kakobuy Spreadsheet",
    seoDescription: "Ranking najlepszych agentów zakupowych 2026: Kakobuy, Pandabuy, Sugargoo, CNFans, Superbuy. Porównanie cen, wysyłki i obsługi — który agent jest najlepszy dla Polaków?",
    seoKeywords: "najlepszy agent zakupowy 2026, ranking agentów zakupowych, kakobuy vs, porównanie agentów, spreadsheet kakobuy",
  },
];

export const faqItems = [
  {
    question: "Czym jest Kakobuy Spreadsheet?",
    answer: "Kakobuy Spreadsheet to zaawansowana baza produktowa, która agreguje setki zweryfikowanych ofert z chińskich platform zakupowych w jednym miejscu. Dzięki regularnym aktualizacjom zawsze masz dostęp do najlepszych okazji i sprawdzonych linków produktowych.",
  },
  {
    question: "Czy linki w Spreadsheet są bezpieczne?",
    answer: "Tak, wszystkie linki przekierowujące do kaspreadsheet.com są regularnie weryfikowane przez nasz zespół. Każdy produkt przechodzi kontrolę jakości, a nieaktualne oferty są natychmiast usuwane. Bezpieczeństwo Twoich zakupów jest naszym priorytetem.",
  },
  {
    question: "Jak często aktualizowana jest baza produktów?",
    answer: "Spreadsheet Kakobuy jest aktualizowany codziennie — monitorujemy ceny, dostępność i jakość produktów w czasie rzeczywistym. Dzięki temu zawsze otrzymujesz najbardziej aktualne informacje i najlepsze okazje cenowe.",
  },
  {
    question: "Czy Kakobuy Spreadsheet jest darmowy?",
    answer: "Tak, dostęp do pełnej bazy Kakobuy Spreadsheet jest całkowicie darmowy. Nie wymagamy rejestracji, logowania ani żadnych opłat. Wszystkie linki, poradniki i porównania są dostępne bezpłatnie dla każdego użytkownika.",
  },
  {
    question: "Jakie kategorie produktów obejmuje baza?",
    answer: "Nasza baza obejmuje szeroki zakres kategorii: obuwie (Shoes, Sneakers, Jordan, Nike, Adidas), odzież (Hoodies, T-Shirts, Jackets, Pants, Jersey), akcesoria (Bags, Belts, Headwear, Perfumes) oraz wiele innych — łącznie 14 głównych kategorii produktowych.",
  },
  {
    question: "Jak bezpiecznie robić zakupy przez Kakobuy?",
    answer: "Zawsze korzystaj ze zweryfikowanych linków z naszego Spreadsheet, porównuj ceny między różnymi ofertami, czytaj opinie innych kupujących i realizuj płatności wyłącznie przez oficjalny sklep kaspreadsheet.com, który zapewnia pełną ochronę kupującego.",
  },
];

export const comparisonData = [
  {
    agent: "Kakobuy",
    price: 9.5,
    shipping: 9.0,
    service: 9.5,
    overall: 9.3,
  },
  {
    agent: "Pandabuy",
    price: 8.0,
    shipping: 8.0,
    service: 8.5,
    overall: 8.2,
  },
  {
    agent: "Sugargoo",
    price: 8.5,
    shipping: 7.5,
    service: 8.0,
    overall: 8.0,
  },
  {
    agent: "CNFans",
    price: 7.5,
    shipping: 7.0,
    service: 7.5,
    overall: 7.3,
  },
  {
    agent: "Superbuy",
    price: 7.0,
    shipping: 8.5,
    service: 8.0,
    overall: 7.8,
  },
];